import { useNotify } from '@globaleris/ui.library'
import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography
} from '@material-ui/core'
import { Check, Close } from '@material-ui/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { generateUniqueKeyWithNoPrefix } from '../../helpers'
import { ServiceResponseError } from '../../model/serviceResponse'

export interface ErrorDetailListProps {
  id?: string | null
  open: boolean
  shortMessage: string
  errors: ServiceResponseError[] | null
  onClose: () => void
}

export const ErrorDetailList: React.FC<ErrorDetailListProps> = ({
  id = null,
  open = false,
  errors,
  shortMessage,
  onClose
}) => {
  const [t] = useTranslation(['errorDetailList', 'rulebook'])
  const { info, error } = useNotify()
  const [showDetail, setShowDetail] = React.useState<boolean>(false)

  const getIcon = (error: any): JSX.Element => {
    switch (error.code.toString()) {
      case '204':
      case '200':
      case '201': {
        return <Check color="primary" />
      }
      default: {
        return <Close color="error" />
      }
    }
  }

  React.useEffect(() => {
    if (open) {
      console.log(errors)
      if (errors === null || (errors.length === 1 && errors[0].code !== '412')) {
        error(shortMessage)
      } else {
        info('Error de rulebook', {
          label: t('errorDetailList:actions.viewDetail'),
          onClick: () => {
            setShowDetail(true)
          }
        })
      }
    } else {
      setShowDetail(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  const getDescription = (error: ServiceResponseError): JSX.Element => {
    return (
      <ul>
        {error.message
          ? error.message.split(',').map((err, index) => {
              return (
                <li>
                  <Typography key={index} variant="caption">
                    {t(`rulebook:${err.toString()}`)}
                  </Typography>
                </li>
              )
            })
          : undefined}
      </ul>
    )
  }

  return (
    <>
      {errors && (
        <Dialog onClose={onClose} open={showDetail} maxWidth="sm" fullWidth>
          <DialogTitle>{t('errorDetailList:title')}</DialogTitle>
          <DialogContent dividers>
            <List dense={true}>
              {errors.map(error => {
                return (
                  <ListItem key={generateUniqueKeyWithNoPrefix()}>
                    <ListItemAvatar>
                      <Avatar>{getIcon(error)}</Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={error.id ?? id ?? undefined}
                      secondary={getDescription(error)}
                    />
                  </ListItem>
                )
              })}
            </List>
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose} color="primary">
              {t('errorDetailList:actions.close')}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  )
}
